export default LoginController;

/** @ngInject */
function LoginController(Usuario, Navegacao) {
  var vm = this;

  vm.usuario = {};
  vm.login = login;

  function login() {
    return Usuario.login(vm.usuario).then(() => Navegacao.voltar(true));
  }
}



/** WEBPACK FOOTER **
 ** ./pages/consulta/usuario/login.controller.ts
 **/